import type { FaireThemeEntity } from "../../entity_types/theme";

export const spiritual_garden_sanctuary: FaireThemeEntity = {
  token: "spiritual-garden-sanctuary",
  type: "theme",
  name: "Spiritual Garden Sanctuary",
  description: "Bring the tranquility of your crystals and Vedic practices into the outdoors. This collection of garden decor and figurines helps your customers create a mindful sanctuary in their own backyards.",
  teaser: "Your shop's core identity revolves around 'crystal healing,' 'body, mind & spirit' books, and 'shamanic practices.' Extending this vibe to garden decor is a natural lifestyle expansion for your existing clientele.",
  detail: "The additional context shows a recent search for 'garden decor,' which complements your existing interests in 'spiritual stones' and 'decorative figurines.'",
  bgColor: "#D4FFD4",
  tileBgColor: "#4a6b36",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_mgvmr3putu",
    "p_4z77wnfamb",
    "p_wd39mugq2p",
    "p_atkpn5ns2e",
    "p_xm4f4x52ww",
    "p_xaz49bd4e7",
    "p_2h2hw7d9q9",
    "p_sxzg8haxcc",
    "p_ugh8ue7mhe",
    "p_vvufs2x8er",
    "p_qnf2n9b9tz",
    "p_2dtqnev25t",
    "p_j52wa88bq2",
    "p_zqfa567gtg",
    "p_938pdphds7",
    "p_xncq4d9gkn",
    "p_zzq38g3qv7",
    "p_9sksmnwt7t",
    "p_pka8nuv4yx",
    "p_jvzkgxjn8e",
    "p_k3g6nexf2c",
    "p_5qdsy7a997",
    "p_hc4j293vhr",
    "p_tpww9nhj8f",
    "p_ag5vgr3r9g",
    "p_xrquq6bnnp",
    "p_vmp8hdrknp",
    "p_4qzqmsur49",
    "p_8z39ej2srs",
    "p_72zquujxbk",
    "p_upbspqmj2w",
    "p_kcr4e5zzjx",
    "p_2m829kmbt4",
    "p_xm7ydsfvv3",
    "p_9fc6dy7j74",
    "p_jvrbfcvnnx",
    "p_d6xdpe6my8",
    "p_wd5xmnwyr7",
    "p_eugbp558sn",
    "p_9tfcvjg964",
    "p_zf6edrrmfr",
    "p_v6z9pyzyjj",
    "p_h8eyp679en",
    "p_qwzy2f6d9b",
    "p_aa7ex4avg2",
    "p_fdwecku67j",
    "p_vmcr29rcv2",
    "p_ktpz5kb26x",
    "p_sn2h8xyxvb",
    "p_m5fmbdt3ek",
    "p_2h79rmxjbn",
    "p_seyz7evw6n",
    "p_9nbdxk85md",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
